import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms'


import { Template } from '../../../../_models/template';
import { CardSvg } from '../../../../_models/card-svg';

@Component({
  selector: 'app-update-usps',
  templateUrl: './update-usps.component.html',
  styleUrls: ['./update-usps.component.css']
})
export class UpdateUspsComponent implements OnInit, OnChanges {
  @Input() template: Template;
  @Output() svg = new EventEmitter<string>();
  uspsForm: FormGroup;
  cardSvg: CardSvg;
  numberOfLines: number = 0;

  constructor(private formBuilder: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges) {
    // Only extract values from the update, if it regards updates on other attributes than our usps
    if (!changes.template.firstChange && changes.template.currentValue.svg === changes.template.previousValue.svg) {
      this.extractDataFromSVG();
    }
  }

  ngOnInit() {
    this.uspsForm = this.formBuilder.group({
      'usps': [],
    });
    this.uspsForm.valueChanges.subscribe(data => {
      this.loadTextareaToImage(data);
    });
    this.extractDataFromSVG();
  }

  extractDataFromSVG() {
    this.cardSvg = new CardSvg(this.template.svg);
    this.numberOfLines = this.cardSvg.numberOfUSPS;
    this.loadValuesToTextarea();
  }

  loadTextareaToImage(data) {
    let lines = data.usps.split('\n');
    lines.forEach((item, index) => {
      if (item === '') { item = '&nbsp;'}
      let selector = '.usp_' + index;
      this.cardSvg.setValue(selector, item);
    });
    this.svg.emit(this.cardSvg.svg_html);
  }

  loadValuesToTextarea() {
    const usps = this.cardSvg.getValueIfItExists(CardSvg.usps_selector, true);
    let formValue = '';
    for (let usp of usps.children) {
      // Trim removes trailing white spaces
      let value = usp.innerHTML.trim();
      if (value === '&nbsp;') { value = ''}
      formValue += value + '\n';
    }
    // Replace all trailing /n's
    this.uspsForm.setValue({
      'usps': formValue.replace(/\n+$/, '')
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/modify-card/update-usps/update-usps.component.ts